export const coreValues = [
  {
    title: 'Integrity',
    body: 'We tell operators the truth about their numbers, even when it is uncomfortable.',
  },
  {
    title: 'Innovation',
    body: 'We pair proven operating discipline with modern technology and AI.',
  },
  {
    title: 'Accountability',
    body: 'We measure our work by the results it produces on your P&L.',
  },
  {
    title: 'Excellence',
    body: 'We standardize to the highest achievable level, not the easiest one.',
  },
  {
    title: 'Results',
    body: 'Every engagement is designed to move profitability in a measurable way.',
  },
]

export const leadershipHighlights = [
  '27+ years of experience',
  'Executive Chef',
  'VP of Operations',
  'Multi-unit leadership',
  'Restaurant consultant',
  'Technology innovator',
]
